// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a8ea097f","703":"417ddf00"}[chunkId] + ".chunk.js";
};